export const CART_PAYMENT_FOOTER = 'cart-payment-footer';
